import React from 'react';
import type {PartValueRenderer} from 'schema/types';
import {FormatIcon, Layout} from 'components';

export const ProductForm: PartValueRenderer = ({value}) => {
  if (typeof value === 'string') {
    return (
      <Layout flex={1} adjustLeft horizontal>
        {value ? <FormatIcon productForm={value} /> : null}
      </Layout>
    );
  }

  return null;
};
